// ─────────────────────────────────────────────────────────────────────────
// SERGA // PERSONAL OS — SONIC mock library
// A self-contained music library shaped like the Spotify Web API objects the
// real backend will return, so swapping mock → live is a data swap, not a
// rewrite. Tracks carry the fields the UI reads (title/artist/album/durMs +
// an `art` descriptor for the procedural cover). All content is original.
//
// art descriptor → buildCover() in sonic.js paints a two-tone bracketed node:
//   { h: <hue 0-360>, motif: 'disc'|'diamond'|'arc'|'bars'|'grid' }
// Hues share the OS's restrained chroma so covers sit inside the field, not
// on top of it.
// ─────────────────────────────────────────────────────────────────────────

export const TRACKS = [
  { id: 's1',  title: 'Smíchov, 4 a.m.',        artist: 'Halôs',          album: 'Night Tariff',        durMs: 254000, art: { h: 188, motif: 'arc' } },
  { id: 's2',  title: 'Apostille',              artist: 'Vẹra Holan',     album: 'Recursion',           durMs: 201000, art: { h: 168, motif: 'disc' } },
  { id: 's3',  title: 'Cold-Load Spike',        artist: 'Telemetry',      album: 'Month-One Schema',    durMs: 312000, art: { h: 212, motif: 'bars' } },
  { id: 's4',  title: 'Seven Primitives',       artist: 'Godot 4',        album: 'Thin Shell',          durMs: 228000, art: { h: 150, motif: 'grid' } },
  { id: 's5',  title: 'Runway Math',            artist: 'Líny Forecast',  album: 'Small Optimisations', durMs: 176000, art: { h: 44,  motif: 'diamond' } },
  { id: 's6',  title: 'Direct Line',            artist: 'MV Channel',     album: 'Second Ring',         durMs: 243000, art: { h: 196, motif: 'arc' } },
  { id: 's7',  title: 'Spatial Field',          artist: 'Nodewalk',       album: 'Fly To Everything',   durMs: 287000, art: { h: 264, motif: 'disc' } },
  { id: 's8',  title: 'Quiet Interregnum',      artist: 'Halôs',          album: 'Night Tariff',        durMs: 198000, art: { h: 184, motif: 'bars' } },
  { id: 's9',  title: 'Boring Exit',            artist: 'Zápočet',        album: 'Clean Wind-Down',     durMs: 221000, art: { h: 20,  motif: 'diamond' } },
  { id: 's10', title: 'Reading the Statute',    artist: 'Vẹra Holan',     album: 'Recursion',           durMs: 265000, art: { h: 158, motif: 'grid' } },
  { id: 's11', title: 'Prague Spring (compile)',artist: 'Nodewalk',       album: 'Fly To Everything',   durMs: 209000, art: { h: 272, motif: 'arc' } },
  { id: 's12', title: 'Apostille (reprise)',    artist: 'Vẹra Holan',     album: 'Recursion',           durMs: 142000, art: { h: 172, motif: 'disc' } },
];

const byId = id => TRACKS.find(t => t.id === id);

export const PLAYLISTS = [
  { id: 'pl-focus',   name: 'DEEP FOCUS',        note: 'compile-and-paperwork',  art: { h: 188, motif: 'bars' },
    trackIds: ['s3', 's4', 's10', 's1', 's8', 's7'] },
  { id: 'pl-late',    name: 'NIGHT TARIFF',      note: 'after midnight, low BPM', art: { h: 264, motif: 'arc' },
    trackIds: ['s1', 's8', 's11', 's7', 's6'] },
  { id: 'pl-runway',  name: 'RUNWAY',            note: 'optimistic, forward',     art: { h: 44,  motif: 'diamond' },
    trackIds: ['s5', 's9', 's2', 's6', 's12'] },
  { id: 'pl-field',   name: 'THE FIELD',         note: 'ambient · spatial',       art: { h: 168, motif: 'disc' },
    trackIds: ['s7', 's11', 's2', 's10', 's4', 's3'] },
];

export const DEVICES = [
  { id: 'dev-desk',  name: 'STUDIO · DESKTOP',  type: 'laptop',  active: true  },
  { id: 'dev-phone', name: 'PIXEL · SERGE',     type: 'phone',   active: false },
  { id: 'dev-mon',   name: 'KEF · DESK MONITORS', type: 'speaker', active: false },
];

// queue = what plays next; recent = history. Both reference TRACKS by object
// so the UI never has to resolve ids itself.
export const QUEUE  = ['s4', 's10', 's1', 's8', 's7', 's6', 's11'].map(byId);
export const RECENT = ['s5', 's9', 's6', 's12', 's3', 's2'].map(byId);

// the track the player boots paused on
export const INITIAL_TRACK = byId('s2');

// pool the mock draws from to make the "context" feel infinite (after the
// queue drains the player keeps pulling from here, like radio)
export const RADIO = ['s7', 's11', 's3', 's1', 's10', 's4', 's8', 's6'].map(byId);

export { byId as trackById };
